// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"EditAddressModal_checkboxes__89n53","deleteButton":"EditAddressModal_deleteButton__oboBj","helperText":"EditAddressModal_helperText__n0DwE"};